import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, Input, Output, EventEmitter, inject, HostListener, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { p2p_result_node } from "src/app/models/p2p_result_node";
import { p2p_shift_node } from "src/app/models/p2p_shift_node";
import { Analytics10Service } from "src/app/services/analytics10.service";
import { environment } from "src/environments/environment";
import { MessageService } from 'primeng/api'; 
import { AuthService } from 'src/app/services/auth.service';
import { P2pChartComponent } from "../p2p-chart/p2p-chart.component";
import { PainScoreCharts } from "src/app/shared/pain-score-charts/pain-score-charts.component";
import { TreeNode } from "primeng/api";
import { ActivatedRoute } from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocationAccessService, LocationFilter } from "src/app/services/location-access.service";
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';
import { cloneFilterState, DataFilterService, FilterState } from 'src/app/services/data-filter.service';
import { PrintAuthUrlService } from "src/app/services/print-auth-url.service";
import { ThemeColorService } from "src/app/services/theme-color.service";
import { ThemePreferenceService } from "src/app/services/theme-preference.service";
import { skip } from 'rxjs';

@Component({
    selector: "app-analytics-table",
    templateUrl: "./table.component.html",
    styleUrls: ["./table.component.css"],
    standalone: false
})
export class TableComponent implements OnInit, OnChanges, OnDestroy {
    private readonly logger = inject<ILogger>(LOGGER_TOKEN);
    private service = inject(Analytics10Service);
    private messageService = inject(MessageService);
    authService = inject(AuthService);
    private route = inject(ActivatedRoute);
    private locationAccessService = inject(LocationAccessService);
    private dataFilterService = inject(DataFilterService);
    private printAuthUrlService = inject(PrintAuthUrlService);
    private themeColorService = inject(ThemeColorService);
    private themePreferenceService = inject(ThemePreferenceService);

    initialSelectedAdminId: string | null = null;
  pointArray: any = [{
    "contributionMin" : 0.06,
    "contributionMax" : 0.09,
    "groupSize" : 65,
    "points" : 1
},
{
    "contributionMin" : 0.09,
    "contributionMax" : 0.1,
    "groupSize" : 25,
    "points" : 1
},
{
    "contributionMin" : 0.1,
    "contributionMax" : 0.13,
    "groupSize" : 5,
    "points" : 1.3
},
{
    "contributionMin" : 0.13,
    "contributionMax" : 0.17,
    "groupSize" : 5,
    "points" : 1.7
},
{
    "contributionMin" : 0.17,
    "contributionMax" : 0.21,
    "groupSize" : 5,
    "points" : 2
},
{
    "contributionMin" : 0.21,
    "contributionMax" : 0.3,
    "groupSize" : 5,
    "points" : 2.5
},
{
    "contributionMin" : 0.3,
    "contributionMax" : 0.37,
    "groupSize" : 5,
    "points" : 3
},
{
    "contributionMin" : 0.37,
    "contributionMax" : 0.52,
    "groupSize" : 5,
    "points" : 3.2
},
{
    "contributionMin" : 0.52,
    "contributionMax" : 0.65,
    "groupSize" : 5,
    "points" : 3.7
},
{
    "contributionMin" : 0.65,
    "contributionMax" : 0.7,
    "groupSize" : 5,
    "points" : 3.9
},
{
    "contributionMin" : 0.7,
    "contributionMax" : 0.75,
    "groupSize" : 5,
    "points" : 4.2
},
{
    "contributionMin" : 0.75,
    "contributionMax" : 0.8,
    "groupSize" : 5,
    "points" : 4.5
},
{
    "contributionMin" : 0.8,
    "contributionMax" : 1,
    "groupSize" : 5,
    "points" : 5
}];
  @Input() headerEnabled = true;
  @Input() transactionType: any;
  @Input() adminId: any = null;
  @Input() locId: any = null;
  @Input() deId=false;
  @Input() chartFilter: any = null;
  loadingWitnessData=false;
  wasteWitnessesData: any = {
    labels:[],
    datasets:[]
  }
  limitWitnesses=false;
  colorKey:any = {}
  colorMaxIdx = -1
  witnessLineColors = [
    this.themeColorService.resolve('--chart-peer-series-1'),
    this.themeColorService.resolve('--chart-peer-series-2'),
    this.themeColorService.resolve('--chart-peer-series-3'),
    this.themeColorService.resolve('--chart-peer-series-4'),
    this.themeColorService.resolve('--chart-peer-series-5'),
    this.themeColorService.resolve('--chart-peer-series-6'),
    this.themeColorService.resolve('--chart-peer-series-7'),
    this.themeColorService.resolve('--chart-peer-series-8'),
    this.themeColorService.resolve('--chart-peer-series-9'),
    this.themeColorService.resolve('--chart-peer-series-10'),
    this.themeColorService.resolve('--chart-peer-series-11'),
    this.themeColorService.resolve('--chart-peer-series-12'),
    this.themeColorService.resolve('--chart-peer-series-13'),
    this.themeColorService.resolve('--chart-peer-series-14'),
    this.themeColorService.resolve('--chart-peer-series-15'),
  ];
  selectedIds:any=[]
  witnessGroupIDs:any = [];
  loadingSelection=false
  witnessGroupCols:any=['select', 'admins in peer group']
  pcounts = false;
  fcounts = false;
  witnessMed=''
  witnessStartDate!: Date | null
  witnessEndDate!: Date | null
  witnessStartDateDisplay = '';
  witnessEndDateDisplay = '';
  showP2PChart = false;
  weightView = false;
  showPainCharts = false;
  showAverage = false;
  showMinMax = false;
  slideVal = 0;
  selectAll = false;
  @ViewChild('p2pChartComponent') p2pChartComponent!: P2pChartComponent;
  @ViewChild('painScoreCharts') painScoresComponent! : PainScoreCharts
  @ViewChild('radarChart') radarChart: any;
  filterDialog = false;
  @ViewChild("analyticstt") analyticstt!: Table;
  filterOptions: any = {};
  allRecords: any[] = [];
  totalCount: any = 0;
  volAudits: any[] = ['Chart', 'Med Use', 'Waste']
  records: TreeNode[] = [];
  searchDialog = false;
  filter: any = {
    ...this.locationAccessService.buildAuthorizedFilters(
      this.locationAccessService.buildInitialFilters(this.authService.user),
      this.authService.user,
      'locationGroup'
    ),
    serviceGroup: "All"
  };
  filterDraft: any = {};
  private filterState?: FilterState<any>;
  dataLoaded = true;
  loading = true;
  @Output() filterValue = new EventEmitter();
  radarWasteChart!:boolean;
  selectedRow: any = {};
  radarWasteOptions: any = {
    plugins: {
      legend: {
        labels: {
          color: this.themeColorService.resolve('--chart-p2p-legend-text'),
          font: { size: 14 }
        }
      }
    },
    scales: {
      r: {
        pointLabels: { color: this.themeColorService.resolve('--chart-p2p-legend-text'), font: { size: 15 } },
        angleLines: { color: this.themeColorService.resolve('--chart-p2p-radar-grid') },
        grid: { color: this.themeColorService.resolve('--chart-p2p-radar-grid') },
        ticks: { color: this.themeColorService.resolve('--chart-p2p-legend-text'), backdropColor: 'transparent', font: { size: 13 } },
        suggestedMin: 0,
        suggestedMax: 1
      }
    },
    backgroundColor: 'transparent',
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1.1
  };
  footprint: string = environment.footprint;
  locationSelectFilter: any = {
    region: [],
    campus: [],
    facility: [],
    locationGroup: [],
    footprint: environment.footprint,
    changeValue: false
  };
  screenWidth: number = window.innerWidth;
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.colorMaxIdx = -1;
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(x => this.deId = x.deId);
    this.themePreferenceService.preference$
      .pipe(skip(1), takeUntil(this.destroy$))
      .subscribe(() => this.refreshRadarTheme());
    
    this.locationSelectFilter = this.buildLocationSelectFilter();
    this.locationAccessService.applyAuthorizedFilters(this.filter, this.locationSelectFilter, this.authService.user, 'locationGroup');

    this.captureInitialFilter();

  }

  private refreshRadarTheme(): void {
    this.witnessLineColors = Array.from(
      { length: 15 },
      (_, index) => this.themeColorService.resolve(`--chart-peer-series-${index + 1}`)
    );
    const legendText = this.themeColorService.resolve('--chart-p2p-legend-text');
    const grid = this.themeColorService.resolve('--chart-p2p-radar-grid');
    const pointBorder = this.themeColorService.resolve('--chart-p2p-point-border');

    this.radarWasteOptions = {
      ...this.radarWasteOptions,
      plugins: {
        ...this.radarWasteOptions.plugins,
        legend: {
          ...this.radarWasteOptions.plugins.legend,
          labels: {
            ...this.radarWasteOptions.plugins.legend.labels,
            color: legendText
          }
        }
      },
      scales: {
        ...this.radarWasteOptions.scales,
        r: {
          ...this.radarWasteOptions.scales.r,
          pointLabels: { ...this.radarWasteOptions.scales.r.pointLabels, color: legendText },
          angleLines: { ...this.radarWasteOptions.scales.r.angleLines, color: grid },
          grid: { ...this.radarWasteOptions.scales.r.grid, color: grid },
          ticks: { ...this.radarWasteOptions.scales.r.ticks, color: legendText }
        }
      }
    };

    if (Array.isArray(this.wasteWitnessesData?.datasets)) {
      this.wasteWitnessesData = {
        ...this.wasteWitnessesData,
        datasets: this.wasteWitnessesData.datasets.map((dataset: any, index: number) => {
          const colorIndex = dataset.themeColorIndex ?? index;
          const color = this.witnessLineColors[colorIndex % this.witnessLineColors.length];
          return {
            ...dataset,
            borderColor: color,
            pointBackgroundColor: color,
            pointBorderColor: pointBorder,
            pointHoverBackgroundColor: pointBorder,
            pointHoverBorderColor: color
          };
        })
      };
    }

    setTimeout(() => this.radarChart?.refresh());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chartFilter?.currentValue) {
      this.setChartFilter(changes.chartFilter.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  updateScreenWidth(): void {
    this.screenWidth = window.innerWidth; // Update screen width on resize
  }

  private getUtcDateAsLocal(dateValue: any): Date | null {
    if (!dateValue) {
      return null;
    }

    const utcDate = new Date(dateValue);
    if (isNaN(utcDate.getTime())) {
      return null;
    }

    return utcDate;
  }

  private formatTwoDigits(value: number): string {
    return value.toString().padStart(2, '0');
  }

  private formatUtcDateTimeForDisplay(dateValue: any): string {
    const localDate = this.getUtcDateAsLocal(dateValue);
    if (!localDate) {
      return '';
    }

    return `${this.formatTwoDigits(localDate.getMonth() + 1)}/${this.formatTwoDigits(localDate.getDate())}/${localDate.getFullYear()} ${this.formatTwoDigits(localDate.getHours())}:${this.formatTwoDigits(localDate.getMinutes())}`;
  }

  private formatUtcDateForDisplay(dateValue: any): string {
    const localDate = this.getUtcDateAsLocal(dateValue);
    if (!localDate) {
      return '';
    }

    return `${localDate.getFullYear()}-${this.formatTwoDigits(localDate.getMonth() + 1)}-${this.formatTwoDigits(localDate.getDate())}`;
  }

  private formatShiftDateForDisplay(dateValue: any): string {
    if (!dateValue) {
      return '';
    }
    // Parse date-only strings (YYYY-MM-DD) as local time to avoid UTC midnight rollback
    const dateStr = String(dateValue);
    const dateOnlyMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnlyMatch) {
      const year = parseInt(dateOnlyMatch[1], 10);
      const month = parseInt(dateOnlyMatch[2], 10);
      const day = parseInt(dateOnlyMatch[3], 10);
      return `${this.formatTwoDigits(month)}/${this.formatTwoDigits(day)}/${year}`;
    }
    const localDate = this.getUtcDateAsLocal(dateValue);
    if (!localDate) {
      return '';
    }
    return `${this.formatTwoDigits(localDate.getMonth() + 1)}/${this.formatTwoDigits(localDate.getDate())}/${localDate.getFullYear()}`;
  }

  handleClearFilterPills() {
    const regionID = this.filter.regionId ?? 'All';
    const campusID = this.filter.campusId ?? 'All';
    const facilityID = this.filter.facilityId ?? 'All';
    const serviceGroup = this.filter.serviceGroup ?? 'All';
    this.filter = {};
    this.filter.regionId = regionID;
    this.filter.campusId = campusID;
    this.filter.facilityId = facilityID;
    this.filter.serviceGroup = serviceGroup;
    this.clearFilterPills.emit();
  }
  
  openP2PChart(row: any){
    this.p2pChartComponent.pcounts=false
    this.p2pChartComponent.fcounts=false
    this.p2pChartComponent.responseData = []
    this.p2pChartComponent.loadP2PHistory(row)
    this.p2pChartComponent.deId = this.deId
    this.showP2PChart = true
  }
  openPainScores(row: any){
    this.painScoresComponent.deId = this.deId
    this.painScoresComponent.loadAllPatientsData(row)
    this.showPainCharts = true
  }

  getStdBg(stdDevMean: any) {
    if (stdDevMean != null) {
      if (stdDevMean > 2) {
        return "bg-red";
      } else if (stdDevMean > 1 && stdDevMean < 2) {
        return "bg-yellow";
      } else if (stdDevMean < 1) {
        return "bg-green";
      }
    }
    return "";
  }

  getFlagColor(maxStdDeviation: any) {
    if (maxStdDeviation != null) {
      if (maxStdDeviation >= 3) {
        return "/assets/images/icon_red-flag.png";
      } else if (maxStdDeviation >= 1 && maxStdDeviation < 3) {
        return "/assets/images/icon_yellow-flag.png";
      } else if (maxStdDeviation < 1) {
        return "/assets/images/icon_green-flag.png";
      }
    }
    return "";
  }

  getFlagTitle(deviation: any) {
    try {
      return Math.round(deviation * 1000) / 1000;
    } catch {
      return "";
    }
  }

  openFilterModal() {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, this.filter);
    this.filterState = this.dataFilterService.open(this.filterState);
    this.filterDraft = cloneFilterState(this.filterState.draft);
    if (this.dataLoaded)
      this.setFilterOptions(); //loc
    else
      this.filterDialog = !this.filterDialog;
  }

  setFilterOptions() {
    this.dataLoaded = false;
    this.service.fetchFilterOptions({ ...this.filter }).subscribe((res) => {
      this.filterDialog = !this.filterDialog;
      this.filterOptions = res;
      this.filterOptions.userName = [{ label: "All", value: "All" }].concat(
        this.filterOptions.userName.sort().map((item: any, index: any) => {
          if(!this.deId){
            return { label: item, value: item };
          }
          if(this.deId){
            return { 
              label: "AdminName" + (index + 1),
              value: item
            };
          }
        })
      );
      // this.filterOptions.medDescription = [
      //   { label: "All", value: "All" },
      // ].concat(
      //   this.filterOptions.medDescription.sort().map(function (item) {
      //     return { label: item, value: item };
      //   })
      // );
      this.filterOptions.medGroupName = [
        { label: "All", value: "All" },
      ].concat(
        this.filterOptions.medGroupName.sort().map((item: any) => {
          return { label: item, value: item };
        })
      );
      this.filterOptions.shiftworked = [
        { label: "Showing All Shifts", value: "All" },
      ].concat(
        this.filterOptions.shiftworked.sort().map((item: any) => {
          return { label: item, value: item };
        })
      );
      this.filterOptions.userID = [
        { label: "All", value: "All" },
      ].concat(
        this.filterOptions.userID.sort().map((item: any, index: any) => {
          if(!this.deId){
            return { label: item, value: item };
          }
          if(this.deId){
            return { 
              label: "AdminID" + (index + 1),
              value: item
            };
          }
        })
      );
      this.filterOptions.adminGrouping = [
        { label: "All", value: "All" },
      ].concat(
        this.filterOptions.adminGrouping.sort().map((item: any) => {
          return { label: item, value: item };
        })
      );
      this.filterOptions.p2p_type = [
        { label: "All", value: "All" },
        { label: "Med Use", value: "Med Use" },
        { label: "Chart", value: "Chart" },
        { label: "Waste", value: "Waste" },
        { label: "Return", value: "Return" },
        { label: "Cancel", value: "Cancel" },
        { label: "Override", value: "Override" },
        { label: "Removal", value: "Removal" },
        { label: "Full Waste", value: "Full Waste" },
        { label: "Late Waste", value: "Late Waste" },
      ]
      this.filterOptions.p2p = [
        { label: "All", value: "All" },
        { label: "Red", value: "red" },
        { label: "Green", value: "green" },
        { label: "Yellow", value: "yellow" },
      ]
      this.dataLoaded = true;
    });
  }

  submitFilter() {
    this.filterValue.emit(this.filter);
    this.filterRecords();
  }

  submitAdvancedFilter(): void {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, this.filterDraft);
    this.filter = cloneFilterState(this.filterState.applied);
    if (this.chartFilter) {
      this.chartFilter = cloneFilterState(this.filter);
    }
    this.submitFilter();
  }

  closeFilterModal() {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.cancel(this.filterState!);
    this.filterDraft = cloneFilterState(this.filterState.draft);
    this.filterDialog = false;
  }

  loadData() {
    this.service
      .getAnalyticsData(this.transactionType, this.adminId, this.locId)
      .subscribe((res) => {
        this.totalCount = (res as any)["count"];
        this.allRecords = (res as any)["docs"];
        this.records = (res as any)["docs"];
        this.dataLoaded = true;
      });
  }

  @Output() clearFilterPills = new EventEmitter<any>();
  clearFilter() {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, this.filter);
    this.filterState = this.dataFilterService.clear(this.filterState!, [
      'regionId', 'campusId', 'facilityId', 'locationGroup', 'locationGroupingIds',
      'serviceGroup', 'duration', 'adminId', 'locId'
    ]);
    this.filter = cloneFilterState(this.filterState.applied);
    this.filterDraft = cloneFilterState(this.filterState.draft);
    if (this.chartFilter) this.chartFilter = cloneFilterState(this.filter);
    this.analyticstt.reset();
    this.filterValue.emit(cloneFilterState(this.filter));
    this.clearFilterPills.emit(cloneFilterState(this.filter));
    this.filterRecords();
  }

  openPrintUrl(row: any) {
    const url = environment.apiUrl + "print-p2p";
    this.service
      .requestToken({ record_id: row._id })
      .subscribe((res) =>
        this.printAuthUrlService.openAuthenticatedPrint(url + "?token=" + res)
      );
  }

  changeServiceGroup(serviceGroup: any) {
    this.filter.serviceGroup = serviceGroup;
    this.filterRecords();
  }

  submitGlobalFilter() {
    this.filterRecords();
  }

  loadRecordsLazy(event: any) {
    const filter = cloneFilterState(this.filter);
    if (event.sortField) {
      filter.$sortField = event.sortField;
      filter.$sortOrder = event.sortOrder;
    }
    else{
      filter.$sortField = 'numberOfStandardDeviationsMean'
      filter.$sortOrder = -1
    }
    this.filterValue.emit(cloneFilterState(this.filter));
    // if(this.filter.medGroupName){
    //   filter.medGroupName = btoa(this.filter.medGroupName)
    // }
    this.loading = true;
    this.service
      .getAnalyticsPagedData(event["first"], filter, this.adminId)
      .subscribe(
        (res) => {
          // this.filterValue.emit(this.filter);
          this.totalCount = (res as any)["count"];
          this.records = (res as any)["docs"].map(function (val: any) { 
            const node = p2p_result_node.toTreeNode(
              p2p_result_node.fromJSON(val)
            ) as TreeNode
            return node;
          }) as TreeNode[];
          this.dataLoaded = true;
          this.loading = false;

          if ((res as any)["count"] == 0)
          {
            this.messageService.add({
              severity: 'info',
              summary: 'No Results Found.',
              detail: 'Please select different filter criteria.'
            });
          }
        },
        (err) => {
          this.loading = false;
          this.logger.exception(err);
        }
      );
  }

  filterRecords() {
    const obj = {};
    (obj as any)["first"] = 0;
    this.loadRecordsLazy(obj);
  }

  onLocationChanged(event: any) {
    if (!event) return;

    // Handle both initialization and user changes
    const isInitialLoad = !event.changeValue;
    
    this.locationAccessService.applyAuthorizedFilters(this.filter, event, this.authService.user, 'locationGroup');

    // Only load data after location select initialization if adminId and locId are null
    if (isInitialLoad && this.adminId === null && this.locId === null) {
      this.filterRecords();
    } else if (!isInitialLoad) {
      // Always filter records when user changes selection
      this.filterRecords();
    }
  }

  // deSelectChecks() {
  //   this.checkUncheckAll({"target":{"checked":false}})
  // }

  onServiceGrpChanged(event: any){
    this.filter.serviceGroup = event.serviceGroup;
    this.filterRecords();
  }

  removePeertoPeerFilters(filter: any){
    const updatedFilter = cloneFilterState(filter || {});
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, updatedFilter);
    if (this.chartFilter) {
      this.setChartFilter(updatedFilter);
    } else {
      this.filter = cloneFilterState(this.filterState.applied);
    }
    this.submitFilter();
  }

  openPeertoPeerFilter(filter: any){
    this.ensureFilterState();
    this.filterState = this.dataFilterService.submit(this.filterState!, cloneFilterState(filter || {}));
    this.filter = cloneFilterState(this.filterState.applied);
    this.openFilterModal();
  }
  clearTableSearch(){
    this.filter.globalSearch = '';
  }
  setChartFilter(newFilter: any){
    const isNewContext = !this.chartFilter;
    this.chartFilter = cloneFilterState(newFilter || {});
    delete this.chartFilter.device;
    this.filter = cloneFilterState(this.chartFilter);
    if (isNewContext || !this.filterState) this.captureInitialFilter();
    this.filterState = this.dataFilterService.submit(this.filterState!, this.filter);
    this.filterDraft = cloneFilterState(this.filterState.draft);
  }

  refreshToInitialState(): void {
    this.ensureFilterState();
    this.filterState = this.dataFilterService.refresh(this.filterState!);
    this.filter = cloneFilterState(this.filterState.applied);
    this.filterDraft = cloneFilterState(this.filterState.draft);
    if (this.chartFilter) this.chartFilter = cloneFilterState(this.filter);
    this.locationSelectFilter = this.buildLocationSelectFilter();
    this.filterDialog = false;
    this.searchDialog = false;
    this.analyticstt?.reset();
    this.filterValue.emit(cloneFilterState(this.filter));
    this.filterRecords();
  }

  private buildLocationSelectFilter(): LocationFilter {
    const filter = this.locationAccessService.buildInitialFilters(this.authService.user, {
      footprint: this.footprint,
      changeValue: false
    });
    const selectedArea = this.locationAccessService.normalizeValues(this.locId, 'locationGroup');
    if (selectedArea.length) {
      filter.locationGroup = this.locationAccessService.sanitizeSelectedValues(
        selectedArea,
        this.authService.user,
        'locationGroup'
      );
    }
    return filter;
  }

  private captureInitialFilter(): void {
    this.filterState = this.dataFilterService.create(this.filter);
    this.filter = cloneFilterState(this.filterState.applied);
    this.filterDraft = cloneFilterState(this.filterState.draft);
  }

  private ensureFilterState(): void {
    if (!this.filterState) this.captureInitialFilter();
  }
  
  getNodeLevel(node: any) {
    if (node.parent == null) {
      return 1;
    } else if (node.parent.parent == null) {
      return 2;
    } else if (node.parent.parent.parent == null){
      return 3;
    }
    else {
      // this.loadChildData(node.parent.parent, 'shift')
      return 4
    }
  }

  rowClass(rowtype: any) {
    if (rowtype == "Shift Summaries") {
      return "p2p_shift_node_parent";
    } else if (rowtype == "Shift Data") {
      return "p2p_shift_node";
    }
  }

  onNodeExpand(event: any) {
    if (event.node.parent == null){
      const node: TreeNode = event.node;
      if (node.parent == null) {
        node.children!.forEach((childNode) => {
          this.loadChildData(childNode);
        });
        return;
      }}
    else{
      const node: TreeNode = event.node;
      (node.parent as any)['shiftDate'] = node['data']['rawShiftDate'] || node['data']['shiftDate'];
      (node.parent as any)['shiftIndex'] = node.parent!.children!.indexOf(node);
      this.loadChildData(node.parent!,'shift');
      return;
    }
  }

  loadChildData(node: TreeNode, childType = 'result'){
    const filterData = {}
    let indexer = 0
    if (childType == 'result'){
      (filterData as any)['adminId'] = node.parent!['data']['adminId'];
      (filterData as any)['adminGroupingValue'] = node.parent!['data']['adminGroupingValue'];
      (filterData as any)['locationGroupingValue'] = node.parent!['data']['locationGroupingValue'];
      (filterData as any)['shiftworked'] = node.parent!['data']['shiftworked'];
      (filterData as any)['p2pMedId'] = node.parent!['data']['p2pMedId'];
      (filterData as any)['transactionType'] = node.parent!['data']['transactionType'];
      this.loading = true;
      this.service.loadShiftSummaries(filterData).subscribe(
        (response) => {
          let data = [{}]
          if ((response as any)['records'].length > 0){
            data = (response as any)['records']
          
          node.children = data.map((val: any) => {
            (val as any)['index'] = indexer;
            const newVal = p2p_shift_node.toTreeNode(p2p_shift_node.fromJSON(val)) as TreeNode
            newVal.data.rawShiftDate = (val as any)['shiftDate']
            newVal.data.rawShiftDisplayDate = (val as any)['shiftDisplayDate']
            newVal.data.shiftDateDisplay = this.formatShiftDateForDisplay((val as any)['shiftDisplayDate'] || (val as any)['shiftDate'])
            if (indexer == 1){
              indexer = 0 
            }
            else{
              indexer = 1
            }
            return newVal
          })}
          const node_0 = new p2p_shift_node();
          node_0.uom = 'UOM'
          node_0.shiftDate = 'Shift Date'
          node_0.shiftworked = 'Shift Worked'
          node_0.patientCount = 'Shift Patient Count'
          node_0.transType = (filterData as any)['transactionType']
          if ((filterData as any)['transactionType'] == 'Med Use'){
            node_0.adminFlagCount = 'Total Med Used'
            node_0.interactionCount = 'Shift Removals'
            node_0.transactionsVolume = 'Shift Removal Volume'
          }
          // else if (filterData['transactionType'] == 'Waste'){
          //   node_0.adminFlagCount = 'Total Med Wasted'
          //   node_0.interactionCount = 'Total Med Used'
          // }
          else{
            let transType = (filterData as any)['transactionType']
            if(transType == 'Removal'){
              transType = "Remov"
            }
            if(transType == 'Waste' || transType == 'Chart'){
              node_0.adminFlagCount = transType == 'Waste' ? 'Total Volume Wasted' : "Total Volume " + transType + 'ed'
            }
            else {
              node_0.adminFlagCount = 'Total ' + (filterData as any)['transactionType'] + "s"
            }
            node_0.interactionCount = "Total " + (filterData as any)['transactionType'] + "s"
            node_0.transactionsVolume = transType == 'Override'
              ? 'Total Volume Overridden'
              : transType == 'Waste' ? 'Total Volume Wasted' : "Total Volume " + transType + 'ed'
          }
          node.children!.splice(0,0,(p2p_shift_node.toTreeNode(node_0) as TreeNode))
          node.expanded = true
          this.records = [...this.records];
          this.loading = false;
        },
        (err) => { 
          this.logger.exception(err);
          this.loading = false;
        }
      )
    }
    else{
      indexer = 1;
      (filterData as any)['adminId'] = node.parent!['data']['adminId'];
      (filterData as any)['adminGroupingValue'] = node.parent!['data']['adminGroupingValue'];
      (filterData as any)['locationGroupingValue'] = node.parent!['data']['locationGroupingValue'];
      (filterData as any)['shiftworked'] = node.parent!['data']['shiftworked'];
      (filterData as any)['p2pMedId'] = node.parent!['data']['p2pMedId'];
      (filterData as any)['transactionType'] = node.parent!['data']['transactionType'];
      (filterData as any)['shiftDate'] = (node as any)['shiftDate'];
      this.loading = true;
      this.service.loadShiftTransactions(filterData).subscribe(
        (response) => {
          let data = [{}]
          if ((response as any)['records'].length > 0){
            data = (response as any)['records']
          node.children![(node as any)['shiftIndex']].children = data.map((val: any) => {
            (val as any)['index'] = indexer;
            const newVal = p2p_shift_node.toTreeNode(p2p_shift_node.fromJSON(val)) as TreeNode
            newVal.data.rawAdminDateTime = (val as any)['adminDateTime']
            newVal.data.adminDateTimeDisplay = this.formatUtcDateTimeForDisplay((val as any)['adminDateTime'])
            if (indexer == 1){
              indexer = 2 
            }
            else{
              indexer = 1
            }
            return newVal
          })}
          const node_0 = new p2p_shift_node();
          node_0.uom = 'UOM'
          node_0.index = 0
          node_0.adminDateTime = 'Date Time'
          node_0.patientId = 'Patient Id'
          node_0.transType = (filterData as any)['transactionType']
          node_0.locationGrouping = 'Location Group'
          node_0.shiftworked = 'Shift Worked'
          if ((filterData as any)['transactionType'] == 'Med Use'){
            node_0.adminFlagCount = 'Total Med Used'
            node_0.interactionCount = 'Shift Removals'
            node_0.transactionsVolume = 'Shift Removal Volume'
          }
          // else if (filterData['transactionType'] == 'Waste'){
          //   node_0.adminFlagCount = 'Total Med Wasted'
          //   node_0.interactionCount = 'Total Med Used'
          // }
          else{
            let transType = (filterData as any)['transactionType']
            if(transType == 'Removal'){
              transType = "Remov"
            }
            if(transType == 'Waste' || transType == 'Chart'){
              node_0.adminFlagCount = transType == 'Waste' ? 'Total Volume Wasted' : "Total Volume " + transType + 'ed'
            }
            else {
              node_0.adminFlagCount = 'Total ' + (filterData as any)['transactionType'] + "s"
            }
            node_0.interactionCount = "Total " + (filterData as any)['transactionType'] + "s"
            node_0.transactionsVolume = transType == 'Override'
              ? 'Total Volume Overridden'
              : transType == 'Waste' ? 'Total Volume Wasted' : "Total Volume " + transType + 'ed'
          }
          node.children![(node as any)['shiftIndex']].children!.splice(0,0,(p2p_shift_node.toTreeNode(node_0) as TreeNode))
          node.expanded = true
          node.children![(node as any)['shiftIndex']].expanded=true
          this.records = [...this.records];
          this.loading = false;
        },
        (err) => { 
          this.logger.exception(err);
          this.loading = false;
        }
      )
    }
  }

  changeToWeightView(){
    this.weightView=!this.weightView
  }
  getWeightValue(val: any,maxScore: any,doDiv=true,contributionPoints=false){
    if(doDiv){
      if (contributionPoints){
        let score = 0
        for(const obj of this.pointArray){
          if (obj.contributionMin < val && val < obj.contributionMax){
            score = (obj.points/maxScore)*100
            break;
          }
        }
        if (score>0){
          return score
        }
        else
        return val*100
      }
      else{
        return (val/maxScore)*100
        }}
    else {
    return val*100
    }}
  
  getViewTooltip(){
    if(!this.weightView)
    return "Switch to Parameter Weighting View"
    else
    return "Switch to Normal View"
  }

  getAuditTotalTooltip(data: any){
    let groupAvg = 'Could not find it'
    let uom = data.transactionType + 's'
    let groupTotal = 0
    let idvTotal = 0
    if(this.volAudits.includes(data.transactionType)){
      try{groupTotal = data.groupFlagTotal.toFixed(2)}
      catch{groupTotal = 0}
      try{idvTotal = data.adminFlagCount.toFixed(2)}
      catch{idvTotal = 0}
      if(data.uom)
        uom=data.uom
    }

    else{
      groupTotal = data.groupFlagTotal.toString()
      idvTotal = data.adminFlagCount.toString()
    }
    if(data.flagCountAvg)
    {
      if(data.groupSize>5)  
        try{groupAvg = data.flagCountAvg.toFixed(2)}
        catch{groupAvg = '0'}
      else{
        if(data.fullGroup_flagCountAvg)
          groupAvg = data.fullGroup_flagCountAvg.toFixed(2)
        }
    }
    
    const retStr = "Group Total: " + groupTotal.toString() + ' ' + uom + 
    "\nGroup Avg: " + groupAvg.toString() + ' ' + uom + 
    "\n\n Indv. Total: " + idvTotal.toString() + ' ' + uom + 
    "\n Indv. Contribution: " + ((data.adminFlagCount/data.groupFlagTotal)*100).toFixed(2) + "%"
    
    return retStr
  }

  getPatientTotalTooltip(data: any){
    let groupAvg = 0
    let groupTotal = 0
    let cont = ''
    if(data.groupSize>5)  
    {  
      cont = ((data.totalCountofPtscaredforbyAdmin/data.groupTotalPatients)*100).toFixed(2)
      groupAvg = data.averageAdminPatientCount.toFixed(2)
      groupTotal = data.groupTotalPatients.toString()
    }
    else
      if(data.fullGroup_averageAdminPatientCount)
      {
        cont = ((data.totalCountofPtscaredforbyAdmin/data.fullGroup_groupPatientCount)*100).toFixed(2)
        groupAvg = data.fullGroup_averageAdminPatientCount.toFixed(2)
        groupTotal = data.fullGroup_groupPatientCount.toString()
      }
    
      const retStr = "Group Total: " + groupTotal + 
    "\n Group Avg: " + groupAvg + 
    "\n\n Indv. Total: " + data.totalCountofPtscaredforbyAdmin + 
    "\n Indv. Contribution: " + cont + "%"
    
    return retStr
  }

  getPatientContribution(indvTotal: any, groupTotal: any){
    const ans = (indvTotal/groupTotal)*100
    return ans
  }

  getPerPatientTotalTooltip(data: any){
    let uom = data.transactionType + 's'
    let groupStat = 0
    if(this.volAudits.includes(data.transactionType)){
      if(data.uom)
        uom = data.uom
    }
    if(data.groupSize>5)
      try{groupStat = data.groupTotalPerPatient_Avg.toFixed(2)}
      catch{groupStat = 0}
    else
      try{groupStat = data.fullGroup_groupTotalPerPatient_Avg.toFixed(2)}
      catch{groupStat = 0}
    const retStr =  "Group Per Patient Avg: " + groupStat.toString() + ' ' + uom +
    "\n\n Indv. Per Patient Avg: " + data.adminMedBYAdminPts.toFixed(2) + ' ' + uom
    
    return retStr
  }

  getPtPerShiftTotalTooltip(data: any){
    let groupStat = 0
    if(data.groupSize>5)
      try{groupStat = data.patientPerShift_Mean.toFixed(2)}
      catch{groupStat = 0}
    else
      try{groupStat = data.fullGroup_patientPerShift_Mean.toFixed(2)}
      catch{groupStat = 0}
    const retStr =  "Group Pts. Per Shift Avg: " + groupStat.toString() + ' ' +
    "\n\n Indv. Pts. Per Shift: " + data.patientsPerShift.toFixed(2) + ' '
    
    return retStr
  }

  isDeId(name: any){
    if(this.deId && name != 'Patient Id')
      return "xxxxxx xxxxxx"
    else
      return name
  }

  showRadarWaste(row: any){
    this.loadingWitnessData=true
    this.selectedIds = []
    this.loadWasteRadarData(row, true)
    this.radarWasteChart = true;
    return null
  }

  loadWasteRadarData(row: any, getGroup=true){
    this.wasteWitnessesData = {
      labels:[],
      datasets:[]
    }
    if(getGroup){
      this.selectedRow = row
      this.limitWitnesses = false
      this.initialSelectedAdminId = row.adminId;
    }
    row['getGroup'] = getGroup
    row['limitToCommon'] = this.limitWitnesses
    this.selectedRow = row
    this.service.getWasteRadarData(row).subscribe((res) => {
      if (getGroup){
        this.witnessEndDate = this.getUtcDateAsLocal((res as any)['dateRange']['end'])
        this.witnessStartDate = this.getUtcDateAsLocal((res as any)['dateRange']['start'])
        this.witnessStartDateDisplay = this.formatUtcDateForDisplay((res as any)['dateRange']['start'])
        this.witnessEndDateDisplay = this.formatUtcDateForDisplay((res as any)['dateRange']['end'])
        this.selectedIds = [row['adminId']]
        this.witnessGroupIDs = (res as any)['adminGroupData']
        this.witnessMed = row.medGroupName
        this.witnessGroupIDs.forEach((g: any)=> {
          if(g.id != row['adminId'])
            g.isSelected=false
          else
            g.isSelected = true  
        })
      }
      this.wasteWitnessesData.labels = (res as any)['labels'].map((label: any) => this.formatName(label))

      // Map adminId to color and label for legend
      const adminIdToColor: Record<string, string> = {};
      const adminIdToColorIndex: Record<string, number> = {};
      const adminIdToLabel: Record<string, string> = {};
      this.witnessGroupIDs.forEach((g: any, idx: any) => {
        adminIdToColor[g.id] = this.witnessLineColors[idx % this.witnessLineColors.length];
        adminIdToColorIndex[g.id] = idx;
        adminIdToLabel[g.id] = this.deId ? "******, *******" : this.formatName(g.name || g.adminName);
      });

      for (let i=0; i<(res as any)['wasteWitnessData'].length; i++){
        const values: any[] = [];
        (res as any)['labels'].forEach((label: any)=>{
          const dataIndex: number = (res as any)['wasteWitnessData'][i]['witnessData'].findIndex((x: any) => x.witnessName == label)
          if (dataIndex != -1){
            values.push((res as any)['wasteWitnessData'][i]['witnessData'][dataIndex]['count'])
          }
          else{
            values.push(null)
          }
        })
        const adminId = (res as any)['wasteWitnessData'][i]['adminId'];
        const color = adminIdToColor[adminId] || this.witnessLineColors[i % this.witnessLineColors.length];
        const themeColorIndex = adminIdToColorIndex[adminId] ?? i;
        const trendLabel = adminIdToLabel[adminId] || "******, *******";

        this.wasteWitnessesData.datasets.push({
          data:values,
          label:trendLabel,
          fill: false,
          snapGaps:true,
          themeColorIndex,
          borderColor: color,
          pointBackgroundColor: color,
          pointBorderColor: this.themeColorService.resolve('--chart-p2p-point-border'),
          pointHoverBackgroundColor: this.themeColorService.resolve('--chart-p2p-point-border'),
          pointHoverBorderColor: color
        })
      }

      // Update legend colors dynamically
      this.radarWasteOptions.plugins.legend.labels.generateLabels = () => {
        return this.wasteWitnessesData.datasets.map((ds: any, idx: number) => ({
          text: ds.label,
          fillStyle: ds.borderColor,
          strokeStyle: ds.borderColor,
          lineWidth: 2,
          hidden: false,
          index: idx
        }));
      };

      this.loadingWitnessData=false
      this.loadingSelection=false
      setTimeout(() => {
        this.radarChart?.refresh();
      });
    })
  }
  selectWholeGroup(event: any){
    void event;
    for (const witnessGroup of this.witnessGroupIDs) {
      witnessGroup['isSelected'] = !this.selectAll
    }
  }
  witnessIdSelected(event: Event, data: { id: string }) {
    if ((event.target as HTMLInputElement).checked) {
      if (!this.selectedIds.includes(data.id)) {
        this.selectedIds.push(data.id);
        this.add_id_to_waste_witness();
      }
    } else {
      const index: number = this.selectedIds.indexOf(data.id);
      if (index !== -1) {
        this.wasteWitnessesData.datasets.splice(index, 1);
        this.selectedIds.splice(index, 1);
        this.add_id_to_waste_witness();
      }
    }
  }

  add_id_to_waste_witness(){
    this.loadingSelection = true
    const addFilter = {
      "locationGroupingValue": this.selectedRow.locationGroupingValue,
      "adminGroupingValue":this.selectedRow.adminGroupingValue,
      "adminId":this.selectedIds,
      "shiftworked":this.selectedRow.shiftworked,
      "p2pMedId":this.selectedRow.p2pMedId,
      "transactionType":this.selectedRow.transactionType,
      "shiftDate":this.selectedRow.shiftDate}
    this.loadWasteRadarData(addFilter, false)       
  }

  limitWitnessResults(){
    this.loadingSelection = true
    this.limitWitnesses = !this.limitWitnesses
    this.loadWasteRadarData(this.selectedRow, false)
  }

  showSearchDialog(){
    this.searchDialog = true;
  }

  formatName(name: string): string {
    if (!name) return name;
    let formattedName = name.replace(/,\s*/g, ', ');
    
    // Capitalize first letter of each word
    formattedName = formattedName.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    
    return formattedName;
  }
}
